
import { mapGetters } from 'vuex'
import CatalogSlugPageView from '../../components/views/CatalogSlugPageView'
import ErrorComponent from '../../components/common/ErrorComponent.vue'

export default {
  name: 'SlugCatalog',
  components: {
    CatalogSlugPageView,
    ErrorComponent
  },
  async asyncData({ store, route }) {
    const res = await store.dispatch('tracks/getTrack', {
      patch: route.params.slug,
    })
    return {
      trackData: res,
    }
  },
  head() {
    return {
      title: `${this.trackData?.name || this.track?.name}. ${this.trackData.author || this.track.author}. Лицензионная музыка для бизнеса, видео и других проектов`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Купить и скачать лицензионную музыку ${this.trackData.name || this.track.name
            } от ${this.trackData.author || this.track.author
            } для видео, рекламы, радио, телевидения, кино, компьютерных игр и заведений`,
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.trackData.name || this.track.name},  ${this.trackData.author || this.track.author
            }, купить музыку, купить лицензионную музыку, музыка для бизнеса, купить музыку для видео, купить музыку для ютьюб, купить музыку для фильма, купить музыку для игры, купить музыку для заведений, музыка для рекламы, скачать, купить'`,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('tracks', ['track']),
  },
  async mounted() {
    await this.$store.dispatch('tracks/getTrack', {
      patch: this.$route.params.slug,
    })
  },
}
